import { useQuery } from '@tanstack/react-query';

import { apiCall, apiClient } from 'shared/client/apiClient';

export const getCourseDraftById = async (courseDraftId: string, includeDeleted?: boolean) => {
  const data = await apiCall(
    apiClient.GET('/course-drafts/{courseDraftId}', {
      params: { path: { courseDraftId }, query: { ...(includeDeleted && { includeDeleted: 'true' }) } }
    })
  );
  return data;
};

export const courseDraftByIdQueryKey = ({ courseDraftId }: { courseDraftId?: string }) =>
  ['course-draft', { courseDraftId }] as const;

export const useGetCourseDraftByIdQuery = (courseDraftId?: string, options: { enabled?: boolean } = {}) => {
  const { enabled = true } = options;

  return useQuery({
    queryKey: courseDraftByIdQueryKey({ courseDraftId }),
    queryFn: () => getCourseDraftById(courseDraftId as string),
    enabled: enabled && !!courseDraftId
  });
};
